(() => {
  if (customElements.get('origin-partner-gallery')) return;

  customElements.define('origin-partner-gallery', class extends HTMLElement {
    connectedCallback() {
  const editorMotionNode = document.getElementById('EaEditorMotion');
  const editorMotion = editorMotionNode ? JSON.parse(editorMotionNode.textContent) : null;
      if (editorMotion?.gallery === 'single') return;
      const slides = [...this.querySelectorAll('.origin-partner-gallery__slide')];
      if (slides.length < 2) return;

      this.controller = new AbortController();
      const { signal } = this.controller;
      let current = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
      let visible = false;

      const schedule = () => {
        clearTimeout(this.timer);
        if (!visible || document.hidden) return;

        const next = (current + 1) % slides.length;
        const image = slides[next].querySelector('img');
        image.loading = 'eager';
        this.timer = setTimeout(() => {
          if (image.complete && image.naturalWidth > 0) {
            slides[current].classList.remove('is-active');
            slides[current].setAttribute('aria-hidden', 'true');
            slides[next].classList.add('is-active');
            slides[next].setAttribute('aria-hidden', 'false');
            current = next;
          }
          schedule();
        }, Number.isFinite(editorMotion?.galleryInterval) ? Math.max(1000, editorMotion.galleryInterval) : 5000);
      };
      document.addEventListener('visibilitychange', schedule, { signal });
      this.observer = new IntersectionObserver(([entry]) => {
        visible = entry.isIntersecting;
        schedule();
      }, { threshold: 0.1 });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      clearTimeout(this.timer);
    }
  });
})();
